import {
  AggregatedForecastItem,
  ForecastFilter,
  PaginatedForecastResult
} from '../types';
import { PensionScheme } from '../../pensionScheme/types';

export interface IForecastState {
  forecast: PaginatedForecastResult | null;
  forecastFilters: ForecastFilter;
  organizationClients: PensionScheme[];
  aggregatedForecastDetails: AggregatedForecastItem[];
}

export const ForecastState: IForecastState = {
  forecast: null,
  organizationClients: [],
  forecastFilters: {} as ForecastFilter,
  aggregatedForecastDetails: []
};
